module.exports = __webpack_public_path__ + "static/29-b331084c8d79bc5d3614d40b3e0ad401.png";